/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import plcIcon from '@/assets/PLC.svg'

const handleStyleLeft = { left: -2, top: 44 }

function PLCNode({ data, isConnectable }) {
  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} style={handleStyleLeft} />

      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={plcIcon} alt="PLC Logo" className="custom-node-plc-icon-standalone" />
          </div>
          <div className="text-center">
            <b>PLC</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
      <Handle type="target" id="right" position={Position.Right} />
    </div>
  )
}

export default PLCNode
